/**
 * Raw agent form values. `responseFormatSchema` is held as raw JSON text (from the textarea) and is
 * parsed to an object by {@see parseResponseFormatSchema} before being sent as AgentInput.
 */
export interface AgentFormValues {
  name: string;
  aiProfile: string;
  instructions: string;
  allowedTools: string[];
  maxTokensPerSession?: number | null;
  overrideTemperature?: number | null;
  overrideMaxTokens?: number | null;
  overrideTopP?: number | null;
  responseFormatSchema?: string | null;
}

/**
 * Parses the raw response-format-schema JSON text into an object, or null when empty. Throws on
 * invalid JSON; the form's own validator prevents submitting invalid JSON.
 */
export const parseResponseFormatSchema = (
  raw?: string | null,
): Record<string, unknown> | null => {
  if (!raw || raw.trim() === "") {
    return null;
  }

  return JSON.parse(raw) as Record<string, unknown>;
};
